import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const lastUpdated = "January 15, 2024";

  return (
    <div className="privacy-policy">
      <div className="privacy-header">
        <div className="container">
          <div className="navigation">
            <a href="/" className="back-button">
              ← Back to Home
            </a>
          </div>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <section className="policy-section">
            <div className="section-icon">🌿</div>
            <h2>Information We Collect</h2>
            <p>We collect information that you voluntarily provide to us when you interact with our landscaping services. This helps us provide you with the best possible experience and tailor our services to your needs.</p>
            <div className="info-box">
              <h3>We collect information when you:</h3>
              <ul>
                <li>Request a quote for landscaping services</li>
                <li>Schedule a consultation or service</li>
                <li>Contact us through our website</li>
                <li>Subscribe to our newsletter</li>
                <li>Engage with our social media accounts</li>
              </ul>
            </div>
          </section>

          <section className="policy-section">
            <div className="section-icon">🌳</div>
            <h2>How We Use Your Information</h2>
            <p>Your information helps us provide and improve our landscaping services. We use the information we collect to:</p>
            <div className="info-box">
              <ul>
                <li>Provide accurate service quotes and estimates</li>
                <li>Schedule and manage your landscaping services</li>
                <li>Send important service updates and notifications</li>
                <li>Share seasonal landscaping tips and maintenance advice</li>
                <li>Improve our services based on your feedback</li>
              </ul>
            </div>
          </section>

          <section className="policy-section">
            <div className="section-icon">🔒</div>
            <h2>Information Security</h2>
            <p>We implement appropriate security measures to protect your personal information. Your trust is important to us, and we take the protection of your data seriously.</p>
            <div className="info-box">
              <h3>Our security measures include:</h3>
              <ul>
                <li>Secure data storage and transmission</li>
                <li>Regular security assessments</li>
                <li>Limited access to personal information</li>
                <li>Employee privacy training</li>
              </ul>
            </div>
          </section>

          <section className="policy-section">
            <div className="section-icon">📋</div>
            <h2>Your Rights</h2>
            <p>As our valued customer, you have certain rights regarding your personal information:</p>
            <div className="info-box">
              <ul>
                <li>Request access to your personal information</li>
                <li>Update or correct your information</li>
                <li>Opt-out of marketing communications</li>
                <li>Request deletion of your information</li>
              </ul>
            </div>
          </section>

          <section className="policy-section">
            <div className="section-icon">📞</div>
            <h2>Contact Us</h2>
            <p>For questions or concerns about this privacy policy, please contact us:</p>
            <div className="info-box">
              <p>
                Gardenia Landscaping LLC<br />
                PO Box 243<br />
                Seville, FL 32190<br />
                Phone: (386) 864-9197<br />
                Email: gardeniallc3@gmail.com<br />
                Hours: Mon-Fri 8AM-6PM, Sat 9AM-4PM
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 